import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Leaflet is loaded as a global (`L`) via angular.json scripts. Its default marker
// icons are normally resolved by auto-detecting a path from leaflet.css, which breaks
// once the CSS is bundled/hashed by Angular (marker-icon-2x.png / marker-shadow.png 404).
// Point Leaflet at the images we copy to /leaflet via angular.json assets. Setting
// imagePath to a string also disables the auto-detection entirely.
declare const L: any;
if (typeof L !== 'undefined' && L.Icon?.Default) {
  L.Icon.Default.imagePath = 'leaflet/';
}

async function initAndBootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(ref => {
      //LogStatus('Bootstrap success: ' + ref);
    })
    .catch(err => console.error(err));
}

initAndBootstrap();
